/**
 * Constants for the "通知書 vs 合格書" certificate upload warning
 * (IROHANA_MATCH_DEV-330).
 *
 * Business rule: when a file uploaded under 「証明書など」 is tagged as 「特定技能の合格書」
 * but its OCR content contains the substring 「通知書」, display a warning. An additional
 * warning line is shown for talents in the three regulated industries listed below.
 *
 * NOTE: Industry names are matched against master data (`master_company_specific_industry.company_specific_industry`).
 * If a product-side rename happens, this constant must be updated or the msg2 warning
 * will silently stop appearing.
 */

/** OCR substring used to detect a 通知書 (notification document). */
export const NOTIFICATION_KEYWORD = "通知書";

/**
 * Master `documentTypeName` value for the 特定技能の合格書 attachment type.
 * Matched against master attachment document types at runtime to resolve the type id from `attachmentDocumentTypeIds`.
 * Keep in sync with master_attachment_document_type seed; product UI label is "特定技能の合格書"
 * but the DB-stored name is "特定技能合格証等".
 */
export const SPECIFIC_SKILL_CERTIFICATE_LABEL = "特定技能合格証等";

/**
 * Industries that require the formal 合格書 (not a 通知書).
 * Matched against `master_company_specific_industry.companySpecificIndustry` by exact name.
 */
export const INDUSTRIES_REQUIRING_FORMAL_CERTIFICATE = ["建設", "ビルクリーニング", "宿泊"] as const;

/** Warning message shown when a 通知書 is uploaded under the 合格書 type. */
export const CERTIFICATE_WARNING_MESSAGE_NOTIFICATION = "アップロードされたファイルは合格書ではなく通知書です。";

/** Additional message shown for the regulated industries. */
export const CERTIFICATE_WARNING_MESSAGE_FORMAL_REQUIRED = "正式な合格書をアップロードしてください。";
